import { render, staticRenderFns } from "./BpmBizBatchRejectDealModal.vue?vue&type=template&id=c0270570&scoped=true&"
import script from "./BpmBizBatchRejectDealModal.vue?vue&type=script&lang=js&"
export * from "./BpmBizBatchRejectDealModal.vue?vue&type=script&lang=js&"
import style0 from "./BpmBizBatchRejectDealModal.vue?vue&type=style&index=0&id=c0270570&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0270570",
  null
  
)

export default component.exports